import { css } from 'styled-components';
export const srOnly = css `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
export default srOnly;
//# sourceMappingURL=srOnly.js.map